import SideBar from "./SideBar";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfile } from "../../redux/action/authAction";
import EditProfileForm from "./components/EditProfileForm";

const EditProfile = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    // dispatch(fetchProfile());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"Edit Profile"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Edit Profile", path: `${pageRoutes?.home}/` },
        ]}
      />
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            <SideBar />
            <EditProfileForm />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EditProfile;
